import { ContentMenuProps } from "../models/types";

const ContentMenu: React.FC<ContentMenuProps> = ({ contents, onAddSubNode, closeDialog, addNode }) => {
  return (
    <div className="bg-white p-1 box-shadow" style={{ position: 'absolute', top: '40px', borderRadius: '8px', zIndex: 10, width: '200px' }}>
      <div className="flex flex-row justify-between items-center mb-2">
        <div style={{ fontSize: '14px' }}>Content Block</div>
        <img src={require("../assets/node/close.png")} style={{ height: '20px' }} onClick={closeDialog} />
      </div>
      {
        contents.map((content) => {
          return (
            <div key={content.id} className="rounded-[3px] flex flex-row items-center p-1 hover cursor-pointer" onClick={() => (addNode == null ? onAddSubNode(content) : addNode.add(content, addNode.nodes, addNode.setNodes, addNode.position))}>
              <div className="mr-2">
                <img src={content.icon} width={15} />
              </div>
              <div style={{ fontSize: '12px' }}>{content.name}</div>
            </div>
          )
        })
      }
    </div>
  )
}

export default ContentMenu;
